<template>
    <div class="card card-with-shadow border-0 mb-primary">
        
        <app-overlay-loader v-if="preloader"/>
        
        
        <div v-if="selectedAction"
             class="note shadow animate__animated animate__fadeIn mb-1 floating-bar-fixed-bottom">
            <form ref="form" data-url="/form/files" class="mb-0" method="POST">
                
                <div v-if="preloader" class="spinner-bounce upload-spinner">
                    <span class="bounce1"></span><span class="bounce2"></span>
                </div>
                
                <div class="d-flex align-items-center justify-content-center p-3" :class="{'loading-opacity': preloader}">
                    <div class="action-headline">
                        <span>
                        {{ $t('select_file') }}
                    </span>
                </div> 
                <div class="col-sm-6 mb-1">
                    <app-input type="file"
                                :label="$t('upload_your_file')"
                                v-model="inputs.default_file"/>

                </div> 
                <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                    {{ $t('upload') }}
                </button>
                
                </div>
            </form>
        </div>
        
        
        
       
    </div>
</template>

<script>
    import {FormMixin} from '../../../../../../../core/mixins/form/FormMixin.js';

    export default {
        name: "FormFiles",
        mixins: [FormMixin],
        props: {
            selectedAction: {
                required: false,
                type: String,
            },
            selectedId: {
                required: true,
                type: Number,
            },
        },
        data() {
            return {
                preloader: false,
                inputs: {},
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData();
                if (this.inputs.custom_file) {
                    formData.append("custom_file", this.inputs.custom_file);
                    
                }
                if (this.inputs.default_file) {
                    
                    let siteId = this.selectedId;
                    
                    formData.append("default_file", this.inputs.default_file);
                    formData.append("site_id", siteId);
                    
                }
                this.save(formData);
                console.log(formData);
                console.log(this.inputs.default_file.name);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                console.log(res.data);
                this.$emit('getUploadedImage', res.data);
                
            },
            afterFinalResponse() {
                this.preloader = false;
                this.inputs = {};
            },
            afterError({data, status}) {
                if(status === 422)
                    this.$toastr.e(Object.values(data.errors)[0][0])
                else this.$toastr.e(data.message);
            }
        }
    }
</script>
